import ModalChoice, {ref as ModalChoiceRef} from './010#_choice'; // Escolha de modal
import SeguradoBasic, {ref as seguradoBasicRef} from './011#_segurado'; // Primeira tela - Informações basicas do segurado
import Equipamentos, {ref as equipamentosRef} from './012#_equipamentos'; // Primeira tela - Informações basicas do segurado
import Bike, {ref as bikeRef} from './013#_bike'; // Segunda tela - Informações da bike
import Cobertura, {ref as coberturaRef} from './014#_cobertura'; // Terceira tela - Selecionar coberturas
import ResumoCoberturas, {ref as resumoCoberastuRef} from './015#_resumoCoberturas'; // Quarta tela - Resuma das coberturas e valores (Cupom)
import Dados, {ref as dadosRef} from './016#_seguradoDados'; // Quinta tela - Informações avançadasa do segurado
import Link, {ref as linkRef} from './017#_link'; // Sexta tela - Envio de links para o segurado

import Resumo, {ref as resumoRef} from './101#_resumo'; // Primeira tela fluxo corretor - Resumo do que foi feito no outro fluxo
import Foto, {ref as fotoRef} from './102#_foto'; // Segunda tela - Fotos do objeto a ser segurado
/* import Pagamento, {ref as pagamentoRef} from './103#_pagamento'; // Terceira tela - Pagamento */
import Pagamento, {ref as pagamentoRef} from './103#_pagamento'; // Terceira tela - Pagamento
import Sucesso, {ref as sucessoRef} from './104#_sucesso'; // Quarta tela - Sucesso

// 0 - Segurado
// 1 - Corretor

export default (type) => {
  switch (type) {
    case 0:
      return {
        forms: [Resumo, Foto, Pagamento, Sucesso],
        refs: [resumoRef, fotoRef, pagamentoRef, sucessoRef],
      };
    case 1:
      return {
        forms: [ModalChoice, SeguradoBasic, Equipamentos, Bike, Cobertura, ResumoCoberturas, Dados, Link],
        refs: [ModalChoiceRef, seguradoBasicRef, equipamentosRef, bikeRef, coberturaRef, resumoCoberastuRef, dadosRef, linkRef],
      };
    default:
      return {
        forms: [ModalChoice, SeguradoBasic, Equipamentos, Bike, Cobertura, ResumoCoberturas, Dados, Link],
        refs: [ModalChoiceRef, seguradoBasicRef, equipamentosRef, bikeRef, coberturaRef, resumoCoberastuRef, dadosRef, linkRef],
      };
  }
};
